// import { randomUUID } from "crypto";

export function createKey() {
  // var newKey = randomUUID();
  var newKey = Math.random() * 10000000;
  return newKey;
}
